import React from 'react'

import styles from './styles.module.scss'

const typeMap = {
  success: {
    background: '#D1F9CB',
    text: '#32BF1F',
    border: '#BEF3B7',
  },
  warning: {
    background: '#FFD4A5',
    text: '#D77000',
    border: '#E7C88C',
  },
  danger: {
    background: '#FFBDBD',
    text: '#D70000',
    border: '#F77C7C',
  },
  default: {
    background: '#E9E9E9',
    text: '#919191',
    border: '#C6C6C6',
  }
}

const AssetBadge = ({title, type}) => {
  const colors = typeMap[type] || typeMap.default
  return (
    <div className={styles.container} style={{backgroundColor: colors.background, color: colors.text, border: `1px solid ${colors.border}`}}>
      { title }
    </div>
  )
}

export default AssetBadge
